import { createSelector } from "reselect";

import { getCartV2TripItem } from "@app/modules/checkout/utils/cart-v2";
import { getCart } from "@app/modules/results/selectors/state-accessors";
import type { NapiV2SelectedSeat } from "@app/types/napi-v2-passengers-types";

const EMPTY_ARR: NapiV2SelectedSeat[] = [];
export const getAllSelectedSeatsFromCart = createSelector([getCart], cart => {
  if (!cart || !cart.cart) {
    return EMPTY_ARR;
  }

  const trip_item = getCartV2TripItem(cart.cart.items);
  return trip_item
    ? trip_item.passengers.flatMap(pax => pax.selected_seats ?? EMPTY_ARR)
    : EMPTY_ARR;
});
